import { announceAssignmentResourceStatus } from './assignment_resource_list';

document.addEventListener('turbolinks:load', function () {
    const assignmentLibraryContent = document.querySelector('#assignment_resource');
    if (!assignmentLibraryContent) return;

    const assignmentRowSelector = '[data-assignment-resource-id]';
    const detailsTriggerSelector = '.assignment-resource-view-details-trigger';
    const rowInteractionExclusionSelector = [
        '.assignment_resource__main_panel__form__resources__card__primary-checkbox',
        '.assignment_resource__main_panel__form__resources__card__actions-settings'
    ].join(', ');
    let viewDetailsRequest = null;
    let viewDetailsTrigger = null;

    const normalizeResourceIds = (resourceIds) => {
        if (Array.isArray(resourceIds)) {
            return resourceIds.map(resourceId => resourceId.toString()).filter(Boolean);
        }

        if (resourceIds === undefined || resourceIds === null || resourceIds === '') {
            return [];
        }

        return resourceIds.toString().split(',').map(resourceId => resourceId.trim()).filter(Boolean);
    };

    const initializeTooltips = (container) => {
        $(container).find('[data-bs-toggle="tooltip"]').tooltip();
    };

    const initializeViewDetailsDescription = (container) => {
        const $container = $(container);
        const $description = $container.find('.assignment-resource-view-details-modal__description-content');
        const $toggle = $container.find('.assignment-resource-view-details-modal__description-toggle');

        if (!$description.length || !$toggle.length) return;

        const maxLines = parseInt($description.data('maxLines'), 10) || 4;
        const lineHeight = parseFloat(window.getComputedStyle($description.get(0)).lineHeight) || 24;
        const collapsedHeight = Math.ceil(lineHeight * maxLines);

        $description.removeClass('assignment-resource-view-details-modal__description-content--collapsed');
        const shouldShowToggle = $description.get(0).scrollHeight > collapsedHeight + 1;
        $toggle.prop('hidden', !shouldShowToggle).text('Read More');
        $description.addClass('assignment-resource-view-details-modal__description-content--collapsed');

        $toggle.off('click.assignmentResourceDetails').on('click.assignmentResourceDetails', function () {
            $description.removeClass('assignment-resource-view-details-modal__description-content--collapsed');
            $(this).prop('hidden', true);
        });
    };

    const openViewDetails = (trigger) => {
        const modalId = trigger.dataset.modalId || 'assignment-resource-view-details-modal';
        const modalContent = document.getElementById(`${modalId}-content`);
        if (!trigger.dataset.viewDetailsUrl || !modalContent || trigger.getAttribute('aria-busy') === 'true') return;

        const viewDetailsUrl = new URL(trigger.dataset.viewDetailsUrl, window.location.origin);
        const $modal = $(`#${modalId}`);
        viewDetailsRequest?.abort();
        viewDetailsTrigger?.removeAttribute('aria-busy');
        viewDetailsTrigger = trigger;
        trigger.setAttribute('aria-busy', 'true');
        modalContent.setAttribute('aria-busy', 'true');
        announceAssignmentResourceStatus('Loading assignment details.');

        viewDetailsRequest = $.ajax({
            url: viewDetailsUrl.toString(),
            type: 'GET',
            dataType: 'html'
        }).done((html) => {
            modalContent.innerHTML = html;
            modalContent.setAttribute('aria-busy', 'false');
            $modal.attr('aria-labelledby', `${modalId}-title`);
            $modal.off('shown.bs.modal.viewDetails')
                .one('shown.bs.modal.viewDetails', function () {
                    initializeTooltips(modalContent);
                    initializeViewDetailsDescription(modalContent);
                    window.requestAnimationFrame(() => {
                        modalContent.querySelector('.assignment-resource-view-details-modal__close')?.focus();
                    });
                })
                .off('hidden.bs.modal.viewDetails')
                .one('hidden.bs.modal.viewDetails', function () {
                    if (viewDetailsTrigger?.isConnected) viewDetailsTrigger.focus();
                });
            $modal.modal('show');
        }).fail((_xhr, status) => {
            if (status !== 'abort') {
                modalContent.setAttribute('aria-busy', 'false');
                announceAssignmentResourceStatus('Assignment details could not be loaded. Please try again.');
            }
        }).always(() => {
            trigger.removeAttribute('aria-busy');
            viewDetailsRequest = null;
        });
    };

    const bindViewDetailsTriggers = () => {
        $(document)
            .off('click.assignmentResourceDetails', detailsTriggerSelector)
            .on('click.assignmentResourceDetails', detailsTriggerSelector, function (event) {
                event.preventDefault();
                openViewDetails(this);
            });

        $(document)
            .off('click.assignmentResourceRowDetails', assignmentRowSelector)
            .on('click.assignmentResourceRowDetails', assignmentRowSelector, function (event) {
                const target = event.target;
                if (!(target instanceof Element)) return;
                if (target.closest(detailsTriggerSelector)) return;
                if (target.closest(rowInteractionExclusionSelector)) return;
                if (this.dataset.assignmentResourceDragging === 'true') return;

                this.querySelector(detailsTriggerSelector)?.click();
            });

        $('.assignment-sortable')
            .off('sortstart.assignmentResourceDetails sortstop.assignmentResourceDetails')
            .on('sortstart.assignmentResourceDetails', function (_event, ui) {
                ui.item.get(0).dataset.assignmentResourceDragging = 'true';
            })
            .on('sortstop.assignmentResourceDetails', function (_event, ui) {
                window.setTimeout(() => {
                    delete ui.item.get(0).dataset.assignmentResourceDragging;
                }, 0);
            });
    };

    const addToLinksResourceIds = (button) => {
        if (button.dataset.resourceIds !== undefined) {
            return normalizeResourceIds(button.dataset.resourceIds);
        }

        return normalizeResourceIds(button.dataset.resourceId);
    };

    const bindAddToLinksButtons = () => {
        $(document)
            .off('click.assignmentResourceAddToLinks', '.assignment-resource-add-to-links-button')
            .on('click.assignmentResourceAddToLinks', '.assignment-resource-add-to-links-button', function (event) {
                event.preventDefault();

                const resourceGroupId = this.dataset.resourceGroupId;
                if (resourceGroupId) {
                    window.addGroupToCart?.(resourceGroupId, { modalId: this.dataset.modalId });
                    return;
                }

                const resourceIds = addToLinksResourceIds(this);
                if (!window.addToCart || resourceIds.length === 0) return;

                window.addToCart(resourceIds.length === 1 ? resourceIds[0] : resourceIds, {
                    modalId: this.dataset.modalId,
                    resourceIds: resourceIds
                });
            });
    };
    window.bindAddToLinksButtons = bindAddToLinksButtons;

    const setResourceCheckboxes = (resourceIds, checked) => {
        normalizeResourceIds(resourceIds).forEach(resourceId => {
            const checkbox = document.getElementById(`checkbox-${resourceId}`);
            if (checkbox) checkbox.checked = checked;
        });
    };

    const syncResourceCheckboxes = (selectedResourceIds) => {
        const selectedIds = new Set(normalizeResourceIds(selectedResourceIds));
        document.querySelectorAll('.child-check').forEach(checkbox => {
            checkbox.checked = selectedIds.has(checkbox.value.toString());
        });
    };

    const syncGroupCheckboxes = (folderSelectionStates = null) => {
        const childCheckboxes = Array.from(document.querySelectorAll('.child-check'));

        document.querySelectorAll('.group-check').forEach(groupCheckbox => {
            const state = folderSelectionStates?.[groupCheckbox.dataset.resourceGroupId];
            if (state) {
                const totalCount = Number(state.total_count) || 0;
                const selectedCount = Number(state.selected_count) || 0;
                groupCheckbox.checked = totalCount > 0 && selectedCount === totalCount;
                groupCheckbox.indeterminate = selectedCount > 0 && selectedCount < totalCount;
                return;
            }

            const groupChildren = childCheckboxes.filter(child => child.dataset.group === groupCheckbox.dataset.group);
            groupCheckbox.checked = groupChildren.length > 0 && groupChildren.every(child => child.checked);
            groupCheckbox.indeterminate = groupChildren.some(child => child.checked) && !groupCheckbox.checked;
        });
    };

    const updateSelectedCount = (resourceCount) => {
        const count = Number(resourceCount) || 0;
        const hasSelections = count > 0;

        document.querySelectorAll('[data-selected-resource-count]').forEach(element => {
            element.textContent = count;
        });

        document.querySelectorAll('[data-selected-resource-count-badge]').forEach(element => {
            element.textContent = count;
            element.hidden = !hasSelections;
        });

        const clearButton = document.getElementById('clear-resource-cart');
        if (clearButton) clearButton.hidden = !hasSelections;

        const submitButton = document.getElementById('assignment-resource-assign-class');
        if (submitButton) {
            submitButton.disabled = !hasSelections;
            submitButton.setAttribute('aria-disabled', (!hasSelections).toString());
        }
    };

    const populateCart = (data) => {
        const content = document.getElementById('assignment_resource__widget-content');
        if (!content) return;

        content.innerHTML = data.html;
        content.setAttribute('aria-busy', 'false');
        updateSelectedCount(data.resource_count);
        syncResourceCheckboxes(data.selected_resource_ids || []);
        syncGroupCheckboxes(data.folder_selection_states || {});
    };

    const cartRequest = (cartAction, resourceIds, onSuccess, options = {}) => {
        const activeFilters = window.filterData || {};
        $.ajax({
            url: '/assignment_resources/resource_cart',
            type: 'POST',
            dataType: 'JSON',
            data: {
                cart_action: cartAction,
                resource_id: resourceIds,
                resource_group_id: options.resourceGroupId,
                types: activeFilters.types || [],
                courses: activeFilters.courses || [],
                search_word: activeFilters.search_word || ''
            },
            success: function (data) {
                onSuccess?.();
                populateCart(data);
            }
        });
    };

    window.addToCart = (resourceIds, options = {}) => {
        const normalizedIds = normalizeResourceIds(options.resourceIds || resourceIds);

        cartRequest('add', resourceIds, function () {
            setResourceCheckboxes(normalizedIds, true);

            if (options.modalId) {
                $(`#${options.modalId}`).modal('hide');
            }
        });
    };

    window.addGroupToCart = (resourceGroupId, options = {}) => {
        cartRequest('add', null, function () {
            if (options.modalId) {
                $(`#${options.modalId}`).modal('hide');
            }
        }, { resourceGroupId: resourceGroupId });
    };

    const removeFromCart = (resourceIds) => {
        cartRequest('remove', resourceIds, function () {
            setResourceCheckboxes(resourceIds, false);
        });
    };

    const clearCart = () => {
        cartRequest('clear', null, function () {
            document.querySelectorAll('.child-check, .group-check').forEach(checkbox => {
                checkbox.checked = false;
                checkbox.indeterminate = false;
            });
        });
    };

    const bindCartControls = () => {
        $(document)
            .off('click.assignmentResourceCart', '#clear-resource-cart')
            .on('click.assignmentResourceCart', '#clear-resource-cart', function (event) {
                event.preventDefault();
                clearCart();
            });

        $(document)
            .off('click.assignmentResourceCart', '.remove-resource-button')
            .on('click.assignmentResourceCart', '.remove-resource-button', function () {
                removeFromCart(this.dataset.resourceId);
            });

        $(document)
            .off('change.assignmentResourceCart', '.child-check')
            .on('change.assignmentResourceCart', '.child-check', function () {
                if (this.checked) {
                    window.addToCart(this.value);
                } else {
                    removeFromCart(this.value);
                }
                syncGroupCheckboxes();
            });

        $(document)
            .off('change.assignmentResourceCart', '.group-check')
            .on('change.assignmentResourceCart', '.group-check', function () {
                const checked = this.checked;
                const resourceGroupId = this.dataset.resourceGroupId;
                if (resourceGroupId) {
                    cartRequest(
                        checked ? 'add' : 'remove',
                        null,
                        null,
                        { resourceGroupId: resourceGroupId }
                    );
                    return;
                }

                const resourceIds = Array.from(document.querySelectorAll('.child-check'))
                    .filter(child => child.dataset.group === this.dataset.group && !child.disabled)
                    .map(child => {
                        child.checked = checked;
                        return child.value;
                    });

                if (resourceIds.length === 0) return;
                if (checked) {
                    window.addToCart(resourceIds, { resourceIds: resourceIds });
                } else {
                    removeFromCart(resourceIds);
                }
            });
    };

    window.selected_assignments_widget = () => {
        if (!document.getElementById('assignment-resource-selected-panel')) return;

        bindCartControls();
        bindViewDetailsTriggers();
        bindAddToLinksButtons();
        syncGroupCheckboxes();

        cartRequest('fetch', null);
    };

    window.refreshCheckboxAssociations = window.selected_assignments_widget;

    window.selected_assignments_widget();
});
